import { takeEvery, takeLatest } from 'redux-saga/effects';
import editUserById from './editUserById';
import deleteUser from './deleteUser';
import { MODULE_NAME } from '../constants';
import loadById from './loadById';
import createUser from './createUser';
import loadList from './loadList';
import {
  CREATE, DELETE_BY_ID, LOAD_BY_ID, LOAD_LIST, UPDATE,
} from '../../../configs/actionNames';

export default function* sagas() {
  yield takeLatest(MODULE_NAME + LOAD_LIST, loadList);
  yield takeEvery(MODULE_NAME + CREATE, createUser);
  yield takeEvery(MODULE_NAME + LOAD_BY_ID, loadById);
  yield takeEvery(MODULE_NAME + UPDATE, editUserById);
  yield takeEvery(MODULE_NAME + DELETE_BY_ID, deleteUser);
}
